export default __webpack_public_path__ + "static/media/4.45393ff1.jpg";